// import React, { useEffect, useState } from 'react';
// import { Form, Input, Button, Select, Card, Row, Col, DatePicker } from 'antd';
// import { HrmsEmployeeDetailsDto, HrmsEmployeeRequest } from '@gtpl/shared-models/masters';
// import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
// import { HrmsEmpDetService } from '@gtpl/shared-services/masters';
// import { Link, useHistory } from "react-router-dom";
// import { ApplyForLeavesDto, GetAllAvailableLeavesDto, GetEmpAvlLeaves, TypesOfLeavesDto } from '@gtpl/shared-models/hrms';
// import {ApplyForLeavesService, EmployeeLeavesService, HolidaysCalendarService, TypesOfLeavesService } from '@gtpl/shared-services/hrms';
// import moment from 'moment';

// import './apply-for-leaves-form.css';
// import { LeavesDTO } from 'libs/shared-models/hrms/src/lib/employee-leaves/leaves.dto';
// import { create } from 'domain';

// const { Option } = Select;
// const layout = {
//   labelCol: {
//     span: 10,
//   },
//   wrapperCol: {
//     span: 8,
//   },
// };



// const tailLayout = {
//   wrapperCol: {
//     offset: 10,
//     span: 10,
//   },
// };

// /* eslint-disable-next-line */
// export interface ApplyForLeavesFormProps {
//   applyForLeavesData: ApplyForLeavesDto;
//   updateDetails: (hrms: ApplyForLeavesDto) => void;
//   isUpdate: boolean;
//   closeForm: () => void;
// }

// export function ApplyForLeavesForm(
//   props: ApplyForLeavesFormProps
// ) {
//   console.log(props)

//   const [form] = Form.useForm();
//   const [employeeData, setEmployeeData] = useState<HrmsEmployeeDetailsDto[]>([]);
//   const [typesOfLeaveData, setTypesOfLeavesData] = useState<TypesOfLeavesDto[]>([]);
//   const [selectedTypesOfLeaves, setSelectedTypesOfLeaves] = useState<TypesOfLeavesDto[]>([]);
//   const [fromDate, setFromDate] = useState<moment.Moment>(moment());
//   const [toDate, setToDate] = useState<moment.Moment>(moment());
//   const [availableLeaves, setAvailableLeaves] = useState<number>(0);
//   const [totalLeaves, setTotalLeaves] = useState<number>(0);
//   const [holidays, setHolidays] = useState<any>()

//   const { TextArea } = Input;

//   const service = new HrmsEmpDetService();
//   const typesOfLeavesService = new TypesOfLeavesService();
//   const applyforLeavesService = new ApplyForLeavesService();
//   const employeeLeavesService = new EmployeeLeavesService();
//   const holidaysService = new HolidaysCalendarService

//   let history = useHistory();

//   let createdUser = "";
//   if (!props.isUpdate) {
//     createdUser = localStorage.getItem("createdUser");
//   }
//   const disable = () => {
//     form.getFieldValue('employeeCode').disabled = true;
//   }
//   useEffect(() => {
//     getAllActiveEmployeesForLeaves();
//     getAllTypesOfLeaves();
//     getHolidaysCalendar();
//     // getAllAvailableLeaves(props.applyForLeavesData?.typeOfLeave);
//     // if(props.isUpdate){
//     //   form.setFieldsValue({'typeOfLeaveId':props.applyForLeavesData.typeOfLeaveId})
//     // }

//     if (props.isUpdate) {
//       form.getFieldValue('employeeCode').disabled;
//     }
//   }, [])

//   const getAllActiveEmployeesForLeaves = () => {
//     service.getAllActiveEmployeesForLeaves().then(res => {
//       if (res.status) {
//         setEmployeeData(res.data);
//       } else {
//         if (res.intlCode) {
//           setEmployeeData(res.data);
//           // AlertMessages.getErrorMessage(res.internalMessage);
//         } else {
//           //  AlertMessages.getErrorMessage(res.internalMessage);
//         }
//       }
//     }).catch(err => {
//       setEmployeeData([]);
//       // AlertMessages.getErrorMessage(err.message);
//     })
//   }

//   // const getEmployeeDetails = () => {
//   //   const employeeId = form.getFieldValue('employeeId')
//   //   const request = new HrmsEmployeeRequest(employeeId);
//   //   service.getActiveEmployeesById(request).then(res => {
//   //     if (res.status) {
//   //       console.log(res.data.employeeName);
//   //       form.setFieldsValue({
//   //         employeeName: res.data.employeeName,
//   //       });
//   //     } else {
//   //       if (res.intlCode) {
//   //         AlertMessages.getErrorMessage(res.internalMessage);
//   //       } else {
//   //         AlertMessages.getErrorMessage(res.internalMessage);
//   //       }
//   //     }
//   //   }).catch(err => {
//   //     AlertMessages.getErrorMessage(err.message);
//   //   })
//   // }

//   const getAllTypesOfLeaves = () => {
//     typesOfLeavesService.getAllActiveTypesOfLeaves().then(res => {
//       if (res.status) {
//         setTypesOfLeavesData(res.data);
//       } else {
//         if (res.intlCode) {
//           setTypesOfLeavesData([]);
//           AlertMessages.getErrorMessage(res.internalMessage);
//         } else {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         }
//       }
//     }).catch(err => {
//       setTypesOfLeavesData([]);
//       AlertMessages.getErrorMessage(err.message);
//     })
//   }

//   const getAllAvailableLeaves = () => {
//     const employeeId = form.getFieldValue('employeeName');
//     const typeofLeave = form.getFieldValue('typeOfLeave')
//     const req = new GetEmpAvlLeaves(`${new Date().getFullYear()}`, employeeId, typeofLeave)
//     employeeLeavesService.getAllAvailableLeaves(req).then(res => {
//       if (res.status) {
//         setAvailableLeaves(res.data);
//       } else {
//         if (res.intlCode) {
//           setAvailableLeaves(0);
//           AlertMessages.getErrorMessage(res.internalMessage);
//         } else {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         }
//       }
//     }).catch(err => {
//       setAvailableLeaves(0);
//       AlertMessages.getErrorMessage(err.message);
//     })
//   }


//   const createLeave = (Data: ApplyForLeavesDto) => {
//     applyforLeavesService.createLeave(Data).then(res => {
//       if (res.status) {
//         AlertMessages.getSuccessMessage('Leave Applied successfully');
//         history.push('/apply-for-leaves-grid');
//         onReset();
//       } else {
//         if (res.intlCode) {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         } else {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         }
//       }
//     }).catch(err => {
//       AlertMessages.getErrorMessage(err.message);
//     })
//   }

//   const saveData = (values: ApplyForLeavesDto) => {
//     const noofDays = form.getFieldValue('noOfDays');
//     const noofLeaves = availableLeaves;
//     if (noofDays > noofLeaves) {
//       AlertMessages.getErrorMessage('No.of Days cannot be more than No.of Leaves');
//     } else {
//       if (props.isUpdate) {
//         props.updateDetails(values);
//       } else {
//         createLeave(values);
//       }
//     }
//   };

//   const onReset = () => {
//     form.resetFields();
//   }
//   const onFocus = () => {
//     console.log('focus');
//   }

//   const onSearch = (val) => {
//     console.log('search:', val);
//   }

//   const onBlur = () => {
//     console.log('blur');
//   }

//   const handleEmployeeName = () => {
//     const employeeId = form.getFieldValue('employeeName');
//     const request = new HrmsEmployeeRequest(employeeId);
//     service.getActiveEmployeesById(request).then(res => {
//       if (res.status) {
//         form.setFieldsValue({
//           employeeCode: res.data.employeeCode,
//           employeeId: res.data.employeeId
//         });
//       } else {
//         if (res.intlCode) {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         } else {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         }
//       }
//     }).catch(err => {
//       AlertMessages.getErrorMessage(err.message);
//     })
//   }


//   const getEmployeeName = () => {
//     const employeeId = form.getFieldValue('employeeCode')
//     const request = new HrmsEmployeeRequest(employeeId);
//     service.getActiveEmployeesById(request).then(res => {
//       if (res.status) {
//         form.setFieldsValue({
//           employeeName: res.data.employeeName + " " + res.data.employeeLastName,
//         });
//         // getAdjustmentData();
//       } else {
//         if (res.intlCode) {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         } else {
//           AlertMessages.getErrorMessage(res.internalMessage);
//         }
//       }
//     }).catch(err => {
//       AlertMessages.getErrorMessage(err.message);
//     })
//   }

//   const getHolidaysCalendar = () => {
//     holidaysService.getHolidaysForYear().then((res) => {
//       if (res.status) {
//         setHolidays(res.data)
//       } else {
//         setHolidays([])
//       }
//     })
//   }


//   const getNoOfDays = (dateType: string) => {
//     const fromDate = form.getFieldValue('fromDate');
//     const toDate = form.getFieldValue('toDate');
//     const noOfDays = (toDate - fromDate);
//     const firstDay = form.getFieldValue('leaveFromDay');
//     const secondDay = form.getFieldValue('leaveToDay');

//     if (moment(fromDate).format('dddd') === 'Sunday' || moment(toDate).format('dddd') === 'Sunday') {
//       AlertMessages.getErrorMessage('Selected day should not be a sunday');

//       if (dateType == 'fromDate') {
//         setFromDate(moment());
//         form.setFieldsValue({
//           fromDate: moment()
//         })
//       }
//       if (dateType == 'toDate') {
//         form.setFieldsValue({
//           toDate: moment()
//         })
//       }
//       let noOfDays = 0;
//       if (noOfDays == 1) {
//         if ((fromDate == toDate) && (firstDay != 'Full Day' && secondDay != 'Full Day')) {// Half day
//           // finalDays -= 0.5;
//         }
//       } else {
//         if (firstDay == 'Second Half' && secondDay == 'First Half') {// Full day
//           // finalDays -= 1;
//         } else if ((fromDate == toDate) && firstDay != 'Full Day') {// Half day
//           // finalDays -= 0.5;
//         } else if (firstDay == 'Full Day' && secondDay == 'First Half') {
//           // finalDays -= 0.5;
//         }


//       }
//       // if (form.getFieldValue('leaveFromDay') == 'Second Half' || form.getFieldValue('leaveFromDay') == 'First Half') {
//       //   noOfDays = 0.5;
//       // } else {
//       //   noOfDays = 1;
//       // }
//       // // form.setFieldsValue({
//       // //   noOfDays: noOfDays
//       // // })
//       // if (form.getFieldValue('leaveToDay') == 'Second Half' || form.getFieldValue('leaveToDay') == 'First Half') {
//       //   noOfDays = noOfDays + 0.5;
//       // } else {
//       //   noOfDays = noOfDays + 1;
//       // }
//       // if (form.getFieldValue('leaveFromDay'))
//       //   form.setFieldsValue({
//       //     noOfDays: noOfDays
//       //   })
//       return false;
//     } else {
//       if (dateType == 'fromDate') {
//         setFromDate(moment(fromDate));
//         form.setFieldsValue({
//           toDate: moment(fromDate)
//         })
//       }
//       if (dateType == 'toDate') {
//         setToDate(moment(toDate));

//       }

//     }
//     const d1 = moment(form.getFieldValue('fromDate'), 'YYYY-MM-DD');
//     const d2 = moment(form.getFieldValue('toDate'), 'YYYY-MM-DD');
//     // Calc all days used including last day ( the +1 )
//     console.log(d1)
//     console.log(d2)


//     const days = d2.diff(d1, 'days') + 1;

//     console.log('Days:', days);

//     // how many full weekends occured in this time span
//     const weekends = Math.floor(days / 7);

//     console.log('Full Weekends:', weekends);

//     // Subtract all the weekend days
//     let businessDays = days - (weekends * 1);

//     // Special case for weeks less than 7
//     if (weekends === 0) {
//       const cur = d1.clone();
//       for (let i = 0; i < days; i++) {
//         if (cur.day() === 0) {
//           businessDays--;
//         }
//         cur.add(1, 'days')
//       }
//     } else {
//       // If the first day is a sunday we need to account for it
//       if (d1.day() === 0) {
//         console.log('Extra weekend day (Sunday)');
//         businessDays--;
//       }
//     }

//     //find if selected days have holidays from holiday calendar

//     var selectedDates = [];
//     const holidayDates = holidays.map(i => { return moment(i.holidayDate).format("YYYY-MM-DD") });

//     for (var current = d1; current <= d2; current.add(1, 'd')) {
//       selectedDates.push(current.format("YYYY-MM-DD"))
//     }
//     const holidaysMatched = selectedDates.filter(element => holidayDates.includes(element));
//     console.log('holidays matched:', holidaysMatched.length)
//     businessDays = (businessDays - holidaysMatched.length)

//     setTotalLeaves(businessDays);
//     console.log(businessDays)
//     let finalDays = businessDays;
//     // const fromDate = form.getFieldValue('leaveToDay')  
//     if (businessDays == 1) {
//       if ((firstDay == secondDay) && (firstDay != 'Full Day')) {// Half day
//         finalDays -= 0.5;
//       }
//     } else {
//       if (firstDay == 'Second Half' && secondDay == 'First Half') {// Full day
//         finalDays -= 1;
//       } else if ((firstDay == secondDay) && firstDay != 'Full Day') {// Half day
//         finalDays -= 0.5;
//       } else if (firstDay == 'Full Day' && secondDay == 'First Half') {
//         finalDays -= 0.5;
//       } else if (firstDay == 'Second Half' && secondDay == 'Full Day') {
//         finalDays -= 0.5;
//       }
//     }
//     console.log(finalDays)
//     form.setFieldsValue({ noOfDays: finalDays })
//     // ---------------------------------------------------------------
//     // if (form.getFieldValue('leaveToDay') == 'Full Day') {
//     //   form.setFieldsValue({
//     //     noOfDays: businessDays
//     //   })
//     // } else if
//     //   (form.getFieldValue('leaveToDay') == 'Second Half' || form.getFieldValue('leaveToDay') == 'First Half') {
//     //   const leaves = businessDays - 0.5;
//     //   form.setFieldsValue({
//     //     noOfDays: leaves
//     //   })
//     // }
//     // else if (form.getFieldValue('leaveFromDay') == 'Second Half' || form.getFieldValue('leaveFromDay') == 'First Half') {
//     //   const leaves = businessDays - 0.5;
//     //   form.setFieldsValue({
//     //     noOfDays: leaves
//     //   })
//     // }
//     // // else if (form.getFieldValue('leaveFromDay') == 'Second Half' && form.getFieldValue('leaveToDay') == 'First Half') {
//     // //   const leaves = businessDays - 1;
//     // //   form.setFieldsValue({
//     // //     noOfDays: leaves
//     // //   })
//     // // }
//     // else {
//     //   form.setFieldsValue({
//     //     noOfDays: businessDays
//     //   })
//     // };

//   }
//   function disabledDate(current) {
//     // Can not select days before today and today
//     return current && current < fromDate;
//   }

//   return (
//     <Card title={<span style={{ color: 'white' }}>Leave Application</span>}
//       style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={props.isUpdate == true ? "" : <Link to='/apply-for-leaves-grid' ><span style={{ color: 'white' }} ><Button className='panel_button' >View </Button> </span></Link>} >

//       <Form form={form}
//         name="control-hooks"
//         layout="vertical"
//         onFinish={saveData}
//         initialValues={props.applyForLeavesData}
//       >

//         <Form.Item name="applyForLeavesId" style={{ display: "none" }} >
//           <Input hidden />
//         </Form.Item>

//         <Form.Item style={{ display: "none" }} name="createdUser" initialValue={createdUser}>
//           <Input hidden />
//         </Form.Item>

//         <Form.Item style={{ display: "none" }} name="employeeId" >
//           <Input hidden />
//         </Form.Item>

//         <Row gutter={[24, 24]}>
//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item
//               name="employeeName"
//               label="Employee Name"
//               rules={[
//                 {
//                   required: true,
//                   message: "name is required"
//                 },

//               ]}
//             >
//               <Select
//                 showSearch
//                 disabled={props.isUpdate ? true : false}
//                 allowClear
//                 //style={{ width: 210 }}
//                 placeholder="Select Employee Name"
//                 optionFilterProp="children"
//                 onFocus={onFocus}
//                 onBlur={onBlur}
//                 onSearch={onSearch}
//                 onChange={handleEmployeeName}
//               // filterOption={(input, option) =>
//               //   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//               // }

//               >
//                 {employeeData.map((employeeData) => {
//                   return <Option key={employeeData.employeeId} value={employeeData.employeeId + employeeData.employeeLastName}>{employeeData.employeeName} {employeeData.employeeLastName}</Option>
//                 })}
//               </Select>
//             </Form.Item>
//           </Col>

//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8, offset: 2 }} lg={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 2 }} style={{ margin: '1%' }}>
//             <Form.Item
//               name="employeeCode"
//               label="Employee Code"
//               rules={[
//                 {
//                   required: true,
//                   message: "name is required"
//                 },
//               ]}>
//               <Select
//                 showSearch
//                 disabled={props.isUpdate ? true : false}
//                 allowClear
//                 //style={{ width: 210 }}
//                 placeholder="Select Employee Code"
//                 optionFilterProp="children"
//                 onFocus={onFocus}
//                 onBlur={onBlur}
//                 onSearch={onSearch}
//                 onChange={getEmployeeName}
//                 filterOption={(input, option) =>
//                   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                 }

//               >
//                 {employeeData.map((employeeData) => {
//                   return <Option key={employeeData.employeeId} value={employeeData.employeeId}>{employeeData.employeeCode}</Option>
//                 })}
//               </Select>
//             </Form.Item>
//           </Col>


//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item
//               key={Date.now()}
//               name="typeOfLeave"
//               label={<span>Type of Leave || Available Leaves : {(availableLeaves)}</span>}
//               initialValue={props?.applyForLeavesData?.typeOfLeave}
//               rules={[
//                 {
//                   required: true,
//                   message: "Leave is required"
//                 },

//               ]} >

//               <Select
//                 key={Date.now()}
//                 showSearch
//                 placeholder="Select Type of Leave"
//                 optionFilterProp="children"
//                 onFocus={onFocus}
//                 onBlur={onBlur}
//                 onSearch={onSearch}
//                 onChange={getAllAvailableLeaves}
//                 defaultValue={Number(props?.applyForLeavesData?.typeOfLeave) || null}
//                 filterOption={(input, option) =>
//                   option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
//                 }>
//                 <Option key={0} value={null}>Select Type of Leave</Option>
//                 {typesOfLeaveData.map((typesOfLeaveData) => {
//                   return <Option key={typesOfLeaveData.typeOfLeaveId} value={typesOfLeaveData.typeOfLeaveId}>{typesOfLeaveData.typeOfLeave}</Option>
//                 })}
//               </Select>
//             </Form.Item>
//           </Col>

//           {/* <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 8, offset: 2 }} lg={{ span: 8, offset: 2 }} xl={{ span: 6, offset: 2 }} style={{ margin: '1%' }}>
//             <Form.Item name="appliedDate" label="Apply Date" initialValue={moment()}>
//               <DatePicker style={{width:'100%'}} format="YYYY-MM-DD"
//               showToday={true} defaultValue={moment('YYYY-MM-DD')} disabled />
//             </Form.Item>
//           </Col> */}

//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item name="fromDate" label="From Date" initialValue={moment()}>
//               <DatePicker
//                 style={{ width: '100%' }}
//                 format="YYYY-MM-DD"
//                 onChange={(selected) => {
//                   setFromDate(selected);
//                   getNoOfDays('fromDate')
//                 }}
//                 showToday={true} />
//             </Form.Item>
//           </Col>

//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item
//               name="leaveFromDay"
//               label="Leave From Day"
//               rules={[
//                 {
//                   required: true,
//                   message: "Enter a valid Day",
//                   max: 15
//                 }
//               ]}>
//               {<Select
//                 showSearch
//                 onChange={() => getNoOfDays('')}
//                 placeholder="Select Leave To Day"
//               >
//                 <Option key={0} value={null}>Select Leave To Day</Option>
//                 <Option key={1} value={'First Half'}>First Half</Option>
//                 <Option key={2} value={'Second Half'}>Second Half</Option>
//                 <Option key={3} value={'Full Day'}>Full Day</Option>
//               </Select>}
//             </Form.Item>
//           </Col>

//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item name="toDate" label="To Date" initialValue={moment()}>
//               <DatePicker
//                 style={{ width: '100%' }}
//                 format="YYYY-MM-DD"
//                 onChange={() => getNoOfDays('toDate')}
//                 showToday={true}
//               // disabledDate={disabledDate}
//               />
//             </Form.Item>
//           </Col>

//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item
//               name="leaveToDay"
//               label="Leave To Day"
//               rules={[
//                 {
//                   required: true,
//                   message: "Enter a valid Day",
//                   max: 15
//                 }
//               ]}>
//               {<Select
//                 showSearch
//                 onChange={() => getNoOfDays('')}
//                 placeholder="Select Leave To Day"
//               >
//                 <Option key={0} value={null}>Select Leave To Day</Option>
//                 <Option key={1} value={'First Half'}>First Half</Option>
//                 <Option key={2} value={'Second Half'}>Second Half</Option>
//                 <Option key={3} value={'Full Day'}>Full Day</Option>
//               </Select>}
//             </Form.Item>
//           </Col>
//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item name="noOfDays"
//               label="No of Leave days"
//               rules={[
//                 {
//                   required: true
//                 },

//               ]}
//             >
//               <Input disabled />
//             </Form.Item>
//           </Col>

//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item name="leaveReason"
//               label="Reason"
//               rules={[
//                 {
//                   required: true,
//                   message: " Reason is required",max:25
//                 },
//                 {
//                   pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
//                   message: `Should contain only alphabets.`
//                 }
//               ]}
//             >
//               <Input/>
//             </Form.Item>
//           </Col>
//           <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 7, offset: 1 }} lg={{ span: 7, offset: 1 }} xl={{ span: 7, offset: 1 }} style={{ margin: '1%' }}>
//             <Form.Item name="leaveAddress"
//               label="Leave Address"
//               rules={[
//                 {

//                   required: false,
//                   max: 400
//                   //message: " Address is required",
//                   // pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
//                 },

//               ]}>

//               <TextArea rows={2} />
//             </Form.Item>
//           </Col>
//         </Row>
//         <Row>
//           <Col span={24} style={{ textAlign: 'right' }}>
//             <Button type="primary" htmlType="submit">
//               Submit
//             </Button>
//             {/* {(props.isUpdate === true) && */}

//             <Button htmlType="button" style={{ margin: '0 14px' }} onClick={onReset}>
//               Reset
//             </Button>
//             {/* } */}
//           </Col>
//         </Row>
//       </Form>
//     </Card>
//   );
// }

// export default ApplyForLeavesForm;

import { Button, Card, Col, Form, Modal, Row, Tag } from 'antd';
import { useState } from 'react';
import * as XLSX from 'xlsx';
import Papa from 'papaparse';

import { Link, useHistory } from 'react-router-dom';

import React from 'react';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Excel } from 'antd-table-saveas-excel';
import { FileExcelFilled } from '@ant-design/icons';
import { ApplyForLeavesService } from '@gtpl/shared-services/hrms';
import { ApplyForLeavesModelDtoReq } from '@gtpl/shared-models/hrms';
import { IExcelColumn } from 'antd-table-saveas-excel/app';
import moment from 'moment';

export const ApplyForLeavesForm = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const service = new ApplyForLeavesService();
  const [loading, setLoading] = useState(false);
  const [] = useState(null);
  const history = useHistory();
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string[]>([]);

  const importExcel = (file: any[]) => {
    var data = new Uint8Array(file);
    var wb = XLSX.read(data, { type: 'array', cellDates: true });
    let sheet: any[] = [];
    for (const Sheet in wb.Sheets) {
      if (Sheet) {
        if (wb.Sheets.hasOwnProperty(Sheet)) {
          sheet.push(
            XLSX.utils.sheet_to_json(wb.Sheets[Sheet], { raw: true, header: 1 })
          );
        }
      }
    }
    return sheet;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'text/csv') {
      setSelectedFile(event.target.files[0]);
      Papa.parse(event.target.files[0], {
        header: true,
        complete: function (result) {
          {
            const columnArray = [];
            const valueArray = [];

            result.data.map((d) => {
              columnArray.push(Object.keys(d));
              valueArray.push(Object.values(d));
            });
            setData(result.data);
            setColumns(columnArray[0]);
            setValues(valueArray);
          }
        },
        skipEmptyLines: true,
      });
    } else if (
      file &&
      file.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ) {
      setSelectedFile(event.target.files[0]);
      let csvData;
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = async (data) => {
        let csvData1: any = reader.result;
        csvData = importExcel(csvData1);

        const filteredNestedData = csvData.filter((innerData) =>
          innerData.some((row) => row.length > 0)
        );

        const output = filteredNestedData.map((innerData) => {
          const header = innerData[0];
          return innerData
            .slice(1)
            .map((row) => {
              if (row.every((value) => value === '')) {
                return null;
              }
              return row.reduce((acc, value, index) => {
                acc[header[index]] = value;
                return acc;
              }, {});
            })
            .filter((row) => row !== null);
        });
        output[0].forEach((date1) => {
          const fromDate = date1["From Date"];
          const momentFromDate = moment(fromDate, 'DD-MM-YYYY', true); // true to enforce strict parsing
          if (!momentFromDate.isValid()) {
            alert('Invalid date format for From Date. Please use DD-MM-YYYY format.');
            return;
          }
          date1["From Date"] = momentFromDate.add(1, 'day').format('YYYY-MM-DD');

          const toDate = date1["To Date"];
          const momentToDate = moment(toDate, 'DD-MM-YYYY', true); // true to enforce strict parsing
          if (!momentToDate.isValid()) {
            alert('Invalid date format for To Date. Please use DD-MM-YYYY format.');
            return;
          }
          date1["To Date"] = momentToDate.add(1, 'day').format('YYYY-MM-DD');
        });
        setData(output[0]);
      };
    } else {
      alert('Please select a valid .csv file.');
      setSelectedFile(null);
    }
  };
  let createdUser = "";
  // if(!props.isUpdate){
  createdUser = localStorage.getItem("createdUser");
  // }
  const handleUpload = async () => {
    try {
      form.validateFields().then(async () => {
        const req = new ApplyForLeavesModelDtoReq(data, createdUser);
        await service.createLeave(req).then((res) => {
          setLoading(true);
          if (res[0].status) {
            AlertMessages.getSuccessMessage(res[0].internalMessage);
            history.push('/apply-for-leaves-grid');
          } else {
            console.log(res[0].internalMessage, 'failed');
            const messages = [...errorMessage];
            res.forEach((rec) => {
              messages.push(rec.internalMessage)
            })
            setErrorMessage(messages); // Set error message
            setErrorModalVisible(true); // Show error modal
          }
        });
      });
    } catch (error) {
      setErrorMessage(error.message); // Set error message
      setErrorModalVisible(true); // Show error modal
      console.error(error);
    }
  };
  const sampleHolidays = [
    {
      employeeCode: "Emp Code",
      // employeeName: 'Emp Name',
      TypeOfLeave: "Leave Type Sick Leave ,Casual Leave,Privilege Leave",
      fromDate: "2024-05-15",
      toDate: "2024-05-17",
      noOfDays: "3",
      leaveReason: "example reason",
      leaveAddress: "Address"

    },

    // Add more holiday entries as needed
  ];

  // Pass sample data to exportingColumns
  let exportingColumns: IExcelColumn[] = [
    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
      __cellType__: "TypeString",
      render: (text, record) => record.employeeCode ? record.employeeCode : '-'
    },
    // {
    //   title: 'Employee Name',
    //   dataIndex: 'employeeName',
    //   __cellType__: "TypeString",
    //   render: (text, record) => record.employeeName ? record.employeeName : '-'
    // },
    {
      title: 'Type Of Leave',
      dataIndex: 'TypeOfLeave',
      __cellType__: "TypeString",
      render: (text, record) => record.TypeOfLeave ? record.TypeOfLeave : '-'
    },
    {
      title: 'From Date',
      dataIndex: 'fromDate',
      // __cellType__: "TypeDate",
      render: (text, record) => record.fromDate ? record.fromDate : '-'
    },
    {
      title: 'To Date',
      dataIndex: 'toDate',
      // __cellType__: "TypeDate",
      render: (text, record) => record.toDate ? record.toDate : '-'
    },
    {
      title: 'No Of Days',
      dataIndex: 'noOfDays',
      __cellType__: "TypeString",
      render: (text, record) => record.noOfDays ? record.noOfDays : '-'
    },
    {
      title: 'Leave Reason',
      dataIndex: 'leaveReason',
      __cellType__: "TypeString",
      render: (text, record) => record.leaveReason ? record.leaveReason : '-'
    },
    {
      title: 'Leave Address',
      dataIndex: 'leaveAddress',
      __cellType__: "TypeString",
      render: (text, record) => record.leaveAddress ? record.leaveAddress : '-'
    },

  ];

  // Now you can pass sampleHolidays to your Excel export function
  const handleExport = (e: any) => {
    e.preventDefault();

    const currentDate = new Date()
      .toISOString()
      .slice(0, 10)
      .split("-")
      .join("/");

    const excel = new Excel();
    excel.addSheet("Sheet1");
    excel.addColumns(exportingColumns);
    excel.addDataSource(sampleHolidays, { str2num: false });
    excel.saveAs(`apply-leaves-${currentDate}.xlsx`);
  }

  return (
    <Card
      title="Apply Leaves"
      extra={  <>
       <Link to="/apply-manual-leaves">
          <span style={{ color: 'white' }}>
            <Button type={'primary'}>Manual Form</Button>{' '}
          </span>
        </Link>
           <Link to="/apply-for-leaves-grid">
          <span style={{ color: 'white' }}>
            <Button type={'primary'}>View</Button>{' '}
          </span>
        </Link>
        </>
     


      }
    >
      <Form>
        <Row gutter={24}>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <Form.Item label="">
              <input
                type="file"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                onChange={handleFileChange}
              />
              <label style={{ color: 'blue', whiteSpace: 'nowrap' }}>
                Only csv & excel files are allowed
              </label>
            </Form.Item>
          </Col>
          <Col
            xs={{ span: 24 }}
            sm={{ span: 24 }}
            md={{ span: 6 }}
            lg={{ span: 6 }}
            xl={{ span: 6 }}
          >
            <Button
              type="primary"
              onClick={handleUpload}
              loading={loading}
              disabled={!selectedFile}
            >
              Upload
            </Button>
          </Col>
          <Button
            type="default"
            style={{ color: 'green' }}
            onClick={handleExport}
            icon={<FileExcelFilled />}
          >
            Sample Format
          </Button>
        </Row>
      </Form>
      <Modal
      width={605}
        title="warning"
        visible={errorModalVisible}
        onCancel={() => setErrorModalVisible(false)}
        footer={[
          <Button key="back" onClick={() =>{ setErrorModalVisible(false);setLoading(false)}}>
            OK
          </Button>,
        ]}
      >
        {errorMessage.map((rec) => {
          return <Tag color="warning">{rec}</Tag>
        })}
      </Modal>
    </Card>
  );
};

export default ApplyForLeavesForm;
